import { Component, createRef } from 'react'
import { Route, Switch, Redirect, withRouter, matchPath } from 'react-router-dom'
import axios from 'axios'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import classnames from 'classnames'

import { CANCEL_REQUEST, ADMIN_HOME, V2_HOME } from '../constants'
import { routes } from './router.config'
import { Header as AdminHeader } from '../../admin/components/Header'
import { Header as AnalysisHeader } from '../../analysis/components/Header'
import { Footer } from '../components/Footer'
import * as createFilterActions from '../actions/filterInfo'
import { clearSimulationFilter } from '../actions/simulationFilterInfo'
import styles from './routes.module.css'
import { printLog } from '../api/commonV2'

const isMenuList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.isMenuRoute)
        .some((x) => !!matchPath(pathname, x.path))
const isAdminList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.isAdminRoute)
        .some((x) => !!matchPath(pathname, x.path))
const isAnalysisList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.isAnalysisRoute)
        .some((x) => !!matchPath(pathname, x.path))
const isBasicList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.isBasicRoute)
        .some((x) => !!matchPath(pathname, x.path))
const isAdvancedList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.isAdvancedRoute)
        .some((x) => !!matchPath(pathname, x.path))
const isManagedList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.isManagedRoute)
        .some((x) => !!matchPath(pathname, x.path))
const isNeedTokenList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.needToken)
        .some((x) => !!matchPath(pathname, x.path))
const isOnlyGuestList = (t, pathname) =>
    routes(t)
        .filter((cfg) => cfg.onlyGuest)
        .some((x) => !!matchPath(pathname, x.path))
const routeChecker = [isBasicList, isAdvancedList, isManagedList]

function routeGuard(props) {
    const {
        t,
        location: { pathname },
        userInfo: { hasError, userinfo }
    } = props

    const isLogin = hasError === false
    const isLoginUrl = pathname === 'loginiam'

    // 未ログイン × 認証必要ページ → ログイン画面へ
    if (!isLogin && (isNeedTokenList(t, pathname) || pathname === '/')) {
        if (window.sessionStorage.getItem('notUpdate')) {
            window.sessionStorage.removeItem('notUpdate')
        } else {
            return <Redirect to="/loginiam"></Redirect>
        }
        return ' '
    }

    // ログイン済み × ゲスト専用ページ → HOMEへ
    if (isLogin && isOnlyGuestList(t, pathname)) {
        if (userinfo?.isAdmin) {
            return <Redirect to={ADMIN_HOME}></Redirect>
        }
        return <Redirect to={V2_HOME}></Redirect>
    }

    // ログイン済み × ログイン画面 → HOMEへ
    if (isLogin && isLoginUrl) {
        if (props.userInfo?.userinfo?.is_admin) {
            return <Redirect to={ADMIN_HOME}></Redirect>
        }
        return <Redirect to={V2_HOME}></Redirect>
    }

    // 一般ユーザー × 管理者ページ → HOMEへ
    if ((!userinfo || !userinfo.is_admin) && isAdminList(t, pathname)) {
        return <Redirect to={V2_HOME}></Redirect>
    }

    // 管理者 or 未ログイン × 一般メニューページ → 管理者HOMEへ
    if ((!userinfo || userinfo.is_admin) && isMenuList(t, pathname)) {
        return <Redirect to={ADMIN_HOME}></Redirect>
    }

    // 分析権限なし × コンサル分析ページ → HOMEへ
    if ((!userinfo || !userinfo.is_analysis) && isAnalysisList(t, pathname)) {
        return <Redirect to={V2_HOME}></Redirect>
    }

    // 契約プランによるアクセス制御
    const checker = routeChecker[+props.userInfo.contractplan]
    if (
        !['/', '/loginiam', '/verify', '/register'].includes(pathname) &&
        !isAdminList(t, pathname) &&
        checker &&
        !checker(t, pathname) &&
        !pathname.includes('v2')
    ) {
        return <Redirect to={V2_HOME}></Redirect>
    }
}

export class CustomRoutesComponent extends Component {
    constructor(props) {
        super(props)
        this.state = {
            open: true,
            themeLoading: false,
            companyLoading: false,
            countryLoading: false,
            company: '',
            companyName: '',
            theme: '',
            themeName: '',
            country: '',
            countryName: '',

            category1: '',
            category2: '',

            clusterId: '',
            el: createRef()
        }
    }

    componentDidMount() {
        this.setState({
            company: this.props.filterInfo.companyid,
            theme: this.props.filterInfo.themeid,
            country: this.props.filterInfo.countryid,
            countryName: this.props.filterInfo.countryName,
            companyName: this.props.filterInfo.companyName,
            themeName: this.props.filterInfo.themeName,
            category1: this.props.filterInfo.category1,
            category2: this.props.filterInfo.category2
        })
    }

    componentDidUpdate({ location: { pathname: prevPathname } }) {
        const {
            location: { pathname },
            t,
            userInfo
        } = this.props
        if (pathname !== prevPathname) {
            // cancel request by message
            axios.defaultSource.cancel(CANCEL_REQUEST)

            // refresh default source
            axios.defaultSource = axios.CancelToken.source()

            // scroll bar
            if (this.state.el?.current) {
                this.state.el.current.scrollTo(0, 0)
            }

            // event tracking
            if (isMenuList(t, pathname)) {
                printLog({
                    createby: userInfo?.userinfo?.username,
                    tabname: pathname
                })
            }
        }
    }

    renderContent = () => {
        const {
            t,
            location: { pathname }
        } = this.props
        const routesList = routes(t)
        const isAdmin = this.props?.userInfo?.userinfo?.is_admin
        const hasAdminHeaderFooter =
            (isMenuList(t, pathname) || isAdminList(t, pathname)) && !['/faq', '/operatingManual'].includes(pathname)
        const hasAnalysisHeaderFooter = isAnalysisList(t, pathname)
        const hasHeaderFooter = hasAnalysisHeaderFooter || hasAdminHeaderFooter
        return (
            <div className={classnames('flex-column', styles.fullHeight)}>
                {/* header */}
                {hasAdminHeaderFooter && <Route path="/" component={AdminHeader} />}
                {hasAnalysisHeaderFooter && <Route path="/" component={AnalysisHeader} />}

                <div
                    className={classnames('flex-1', styles.content)}
                    style={{ marginTop: hasHeaderFooter ? '20px' : 0 }}
                    ref={this.state.el}
                >
                    {/* routes */}
                    <Switch>
                        <Redirect path="/" exact to={{ pathname: isAdmin ? ADMIN_HOME : V2_HOME }} />
                        {routesList.map((cfg, i) => (
                            <Route key={i} {...cfg} />
                        ))}
                        <Redirect from="*" to={{ pathname: `/404` }} />
                    </Switch>
                </div>

                {/* footer */}
                {hasHeaderFooter && <Route path="/" component={Footer}></Route>}
            </div>
        )
    }

    render() {
        let content = routeGuard(this.props)
        if (!content) {
            content = this.renderContent(this.props)
        }
        return <>{content}</>
    }
}

const mapStateToProps = (state) => {
    return {
        filterInfo: state.filterInfo,
        userInfo: state.userInfo
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        filterInfoActions: bindActionCreators(createFilterActions, dispatch),
        clearSimulationFilter: bindActionCreators(clearSimulationFilter, dispatch)
    }
}

export const CustomRoutes = connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(withRouter(CustomRoutesComponent)))
